"use client";

import React from "react";
import Button from "../../../components/Button";
import overlayStyles from "../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/PrescriptionPreview.module.css";

export default function PrescriptionPreviewModal({
  isOpen,
  onClose,
  onBack, 
  onProceed,
  patientInfo = {
    name: "Morris. T. Mrs",
    patient: "Monica Morris",
    profile: "998565",
    address: ["189 Oak Lane", "Pinetown", "Durban", "3600"],
    phone: "0836470948",
    medicalAid: "Discovery",
  },
  prescription = {
    title: "CERTIFIED COPY OF DOCTORS PRESCRIPTION",
    lines: [
      {
        code: "830747001",
        drug: "ZOXIL SF 250MG SUSP",
        qty: "30",
        side: "OD",
        icd10: "Z76.9",
        price: "R 32.23",
        instructions: [
          "5MLS THREE TIMES A DAY AFTER MEALS FOR 5 DAYS",
          "*ANTIBIOTIC – FINISH THE COURSE *",
          "KEEP REFRIGERATED",
        ],
      },
      {
        code: "717602001",
        drug: "PHARGEL GEO",
        qty: "10",
        side: "OD",
        icd10: "Z76.9",
        price: "R 116.08",
        instructions: ["APPLY TO GUM AREA WHEN NECESSARY"],
      },
    ],
    pharmacy: "Durban North Pharmacy",
    registration: "0602809",
    copyCost: "R0.25",
    total: "R148.56",
  },
}) {
  if (!isOpen) return null;

  return (
    <div className={`${overlayStyles.modalOverlay} ${overlayStyles.show}`}>
      <div className={`${overlayStyles.modalContent} ${styles.modalContent}`}>
        <button className={overlayStyles.closeButton} onClick={onClose}>
          ×
        </button>

        <div className={styles.scrollArea}>
          <section className={styles.card}>
            <h3 className={styles.cardTitle}>PATIENT INFORMATION</h3>
            <div className={styles.infoGrid}>
              <div className={styles.infoRow}>
                <span className={styles.label}>Name:</span>
                <span className={styles.value}>{patientInfo.name}</span>
                <span className={styles.label}>Patient:</span>
                <span className={styles.value}>{patientInfo.patient}</span>
                <span className={styles.label}>Profile:</span>
                <span className={styles.value}>{patientInfo.profile}</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.label}>Address:</span>
                <div className={`${styles.value} ${styles.addressValue}`}>
                  {Array.isArray(patientInfo.address)
                    ? patientInfo.address.map((l, i) => (
                        <div key={i}>{l}</div>
                      ))
                    : patientInfo.address}
                </div>
                <span className={styles.label}>Phone:</span>
                <span className={styles.value}>{patientInfo.phone}</span>
                <span className={styles.label}>Medical Aid:</span>
                <span className={styles.value}>{patientInfo.medicalAid}</span>
              </div>
            </div>
          </section>

          {/* Prescription Card */}
          <section className={styles.card}>
            <h3 className={styles.cardTitle}>{prescription.title}</h3>
            <div className={styles.prescriptionBody}>
              {prescription.lines.map((line, idx) => (
                <div key={idx} className={styles.drugBlock}>
                  <div className={styles.drugHeader}>
                    <span className={styles.code}>{line.code}</span>
                    <span className={styles.sep}>-</span>
                    <span className={styles.drugName}>{line.drug}</span>
                    <span className={styles.flexSpacer} />
                    <span className={styles.qty}>{line.qty}</span>
                    <span className={styles.side}>{line.side}</span>
                    <span className={styles.icd}>ICD10: {line.icd10}</span>
                    <span className={styles.price}>{line.price}</span>
                  </div>
                  {line.instructions?.map((inst, i) => (
                    <div key={i} className={styles.instruction}>
                      {inst}
                    </div>
                  ))}
                </div>
              ))}

              <div className={styles.footerDetails}>
                <div>
                  <div>
                    <span className={styles.label}>Pharmacy:</span>
                    <span className={styles.value}>{prescription.pharmacy}</span>
                  </div>
                  <div>
                    <span className={styles.label}>Registration Number:</span>
                    <span className={styles.value}>{prescription.registration}</span>
                  </div>
                </div>
                <div className={styles.totals}>
                  <div>
                    <span className={styles.label}>Copy:</span>
                    <span className={styles.value}>{prescription.copyCost}</span>
                  </div>
                  <div>
                    <span className={styles.label}>Total excl. VAT:</span>
                    <span className={styles.value}>{prescription.total}</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className={styles.actionBar}>
          {onBack && (
            <Button onClick={onBack} variant="secondary">
              Back
            </Button>
          )}
          <Button onClick={onProceed} variant="primary">
            Proceed to sign
          </Button>
        </div>
      </div>
    </div>
  );
}
